export default __webpack_public_path__ + "static/media/paku24-logo.7602fc02.png";